import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { ridersAddFundsToWallet } from '../../../state/actions/riders'
import { IStoreState } from '../../../types/index'
import AddFundsModal from '.././../../components/riders/riderdetails/wallet/AddFundsModal'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    onClose: ownProps.history.goBack,
    history: ownProps.history,
    match: ownProps.match,
    currentUserId: state.user.currentUserId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    addFunds: (
      riderId: string,
      riderName: string,
      riderEmail: string,
      paymentSourceId: string,
      amount: number,
      currentUserId: string
    ) => {
      return dispatch(ridersAddFundsToWallet(riderId, riderName, riderEmail, paymentSourceId, amount, currentUserId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddFundsModal)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/AddFundsModal.tsx